<template>
  <div class="login-by-phone">
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item prop="phone">
        <el-input
          AUTOCOMPLETE="off"
          v-model="form.phone"
          placeholder="请输入手机号"
          auto-complete="new-password"
        >
          <i slot="prefix" class="m-icon-shouji"></i>
        </el-input>
      </el-form-item>
      <el-form-item class="form-item" prop="code">
        <el-input
          v-model="form.code"
          placeholder="请输入短信验证码"
          auto-complete="new-password"
        >
          <div
            class="verification-class"
            v-if="isShow"
            @click="verification"
            slot="append"
          >
            获取验证码
          </div>
          <div v-else slot="append">{{ count }}秒后再获取</div>
          <i
            slot="prefix"
            class="el-input__icon icon iconfont icon-renzhengguanli"
          ></i>
        </el-input>
        <Vcode :show="visShow" @success="onSuccess" @close="onClose" />
      </el-form-item>

      <el-form-item prop="type">
        <el-checkbox-group v-model="form.type">
          <el-checkbox name="type"></el-checkbox>
          <span class="ruleurlbox"
            >同意我们的<router-link
              :to="{ name: 'rule' }"
              class="ruleurl"
              tag="a"
            >
              <span>使用条款</span>
            </router-link>
            和
            <router-link
              :to="{ name: 'privacy' }"
              class="ruleurl"
              tag="a"
              target="_blank"
              ><span>隐私政策</span></router-link
            ></span
          >
          <span class="forget-password"
            ><router-link :to="{ name: 'findpassword' }"
              >忘记密码?</router-link
            ></span
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')" class="loginbutton"
          >登&nbsp;录</el-button
        >
      </el-form-item>
      <p class="register-line">
        还没有账号?<router-link :to="{ name: 'register' }"
          ><span class="register">立即注册</span>
        </router-link>
      </p>
    </el-form>
  </div>
</template>
  <script>
import LoginTitle from "./LoginTitle.vue";
import { mapActions, mapGetters } from "vuex";
import CountDown from "../common/CountDown.vue";
import Vcode from "vue-puzzle-vcode";

export default {
  components: {
    LoginTitle,
    CountDown,
    Vcode,
  },
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      title: "手机号登录",
      form: {
        phone: "",
        code: "",
        type: [],
      },
      rules: {
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        type: [
          {
            type: "array",
            required: true,
            message: "您还没有同意协议",
            trigger: "change",
          },
        ],
      },
      count: 0,
      isShow: true,
      visShow: false,
      usertype: 1,
    };
  },
  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, (valid) => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some((i) => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let info = {};
          info.type = this.usertype;
          info.username = this.form.phone;
          info.password = "";
          info.router = this.$router;
          info.code = this.form.code;

          this.userLogin(info).then((res) => {
            // console.log("结束了")
            // console.log(res)
          });
        } else {
          return false;
        }
      });
    },
    ...mapActions(["userLogin"]),
    verification() {
      //console.log("开始了");
      //this.$FUnitls.throttle(this.sendCode, 1000);
      this.sendCode();
      //this.sendCode();
    },
    onSuccess(msg) {
      this.visShow = false;
      //可以在此加上axios或其他代码
    },
    onClose() {
      this.visShow = false;
    },
    countdown() {
      this.isShow = false; //倒计时
      // this.visShow = true;
      this.count = 60; //赋值60秒
      var times = setInterval(() => {
        this.count--; //递减
        if (this.count <= 0) {
          // <=0 变成获取按钮
          this.isShow = true;
          clearInterval(times);
        }
      }, 1000); //1000毫秒后执行
    },
    //发送验证码
    sendCode() {
      //console.log("sendcode")
      let info = {};
      info.phone = this.form.phone;
      var reg_tel3 = /^1\d{10}$/;
      if (!reg_tel3.test(info.phone)) {
        this.$FUnitls.showInfo("请输入正确的手机号", "info");
      }

      this.$api.user.sendCode(info).then((res) => {
        // console.log(res);
        // console.log(res.data);
        if (res.data.errno == 0) {
          //console.log("发送成功");
          this.$FUnitls.showInfo("发送成功", "info");
          this.countdown();
        } else {
          this.$FUnitls.showInfo(res.data.msg, "info");
        }
      });
    },
  },
  mounted() {},
};
</script>
  <!--声明语言，并且添加scoped-->
  <style scoped>
  .m-icon-shouji{
    position: relative;
  }
  .m-icon-shouji::after{
    position:absolute;
    content: " ";
    width: 21px;
    height: 24px;
    left: 2px;
    top:12px;
    background: url(/static/login/phone.png) no-repeat;
    background-size: 100% 100%;
  }
.ruleurlbox {
  color: #666666;
  font-size: 14px;
  margin-left: 5px;
}
.ruleurlbox a {
  color: #0464cd;
}
.icon-shouji {
  color: #0464cd;
}
.form-item {
  position: relative;
  margin-bottom: 15px;
}
.register-line {
  text-align: center;
  font-size: 16px;
  color: #666;
}
.register-line .register {
  color: #0464cd;
}
.verification-class {
  cursor: pointer;
}
.login-by-phone >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
  -webkit-text-fill-color: #666 !important;
}

.login-by-phone >>> .el-input--prefix .el-input__inner {
  color: #666;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}

.login-by-phone >>> .el-form-item.is-error .el-input__inner,
.login-by-phone >>> .el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.login-by-phone >>> .el-input--prefix .iconfont.icon-shouji {
  font-size: 28px;
}
.login-by-phone >>> .el-input-group__append,
.login-by-phone >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix {
  padding-top: 2px;
}
.login-by-phone >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}
.login-by-phone >>> .loginbutton {
  width: 100%;
  font-size: 20px;
}
.login-by-phone >>> .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-button {
  border-radius: 26px;
}
.login-by-phone >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.login-by-phone >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.login-by-phone >>> .el-checkbox__inner {
  border-radius: 7px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/user/UserLoginByPhone.vue